import TossHomeV2Container from "@/containers/Toss/homeV2/TossHomeV2Container";

export default function TossHome() {
  return <TossHomeV2Container />;
}
